import { useEffect, useState } from "react";

const fmt = (ms) => {
  const s = Math.floor(ms / 1000), d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60);
  return d > 0 ? `${d}d ${h}h ${m}m` : `${h}h ${m}m ${s % 60}s`;
};

export const Countdown = ({ deadline, closedText, testid }) => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 1000); return () => clearInterval(t); }, []);
  const left = new Date(deadline).getTime() - now;
  return (
    <span className="cd" data-testid={testid}>
      {left > 0 ? <>Faltan <b>{fmt(left)}</b></> : <b>{closedText}</b>}
    </span>
  );
};
